function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a614a534-8121-49d3-974d-b101f0a427be,.bcbe64a1-3cc2-4e27-9849-4a41b2ee4e3f{fill:#fff;}.a012dd07-f557-4197-a834-16b1e761fcc1,.ae273bfa-cafb-46e3-b43b-39332eacf46d{fill:#012;}.a012dd07-f557-4197-a834-16b1e761fcc1{stroke:#000;stroke-width:5px;}.a012dd07-f557-4197-a834-16b1e761fcc1,.a614a534-8121-49d3-974d-b101f0a427be{stroke-miterlimit:10;}.a614a534-8121-49d3-974d-b101f0a427be{stroke:#012;stroke-width:20px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "fe4723fc-beb1-46d5-9545-c96cbff54a8c",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "e7463df4-52d1-4573-a5fb-936783111d32",
  "data-name": "b6edf2a6-14b6-4967-96e9-92d46e85a117"
}, /*#__PURE__*/React.createElement("rect", {
  className: "bcbe64a1-3cc2-4e27-9849-4a41b2ee4e3f",
  x: 116.07,
  y: 182.75,
  width: 296.94,
  height: 272,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "bcbe64a1-3cc2-4e27-9849-4a41b2ee4e3f",
  x: 122.69,
  y: 165.75,
  width: 287.32,
  height: 95.36,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  className: "bcbe64a1-3cc2-4e27-9849-4a41b2ee4e3f",
  x: 116.07,
  y: 443.86,
  width: 299.75,
  height: 27.17,
  rx: 12
}), /*#__PURE__*/React.createElement("path", {
  className: "a012dd07-f557-4197-a834-16b1e761fcc1",
  d: "M269.62,164.41c42.45,0,82.1,4.16,111.33,11.72,17.62,4.54,26.82,9.07,30.84,11.72V450.94c-3.6,2.65-12.81,7.19-30.84,11.72-29.23,7.56-68.88,11.72-111.33,11.72s-82.1-4.16-111.33-11.72c-17.63-4.53-26.82-9.07-30.85-11.72v-263c3.61-2.65,12.82-7.18,30.85-11.72,29.23-7.56,68.87-11.72,111.33-11.72Zm0-15.12c-43.65,0-84.91,4.16-115.74,12.1-29.24,7.56-42.46,16.63-42.46,22.3V455.1c0,5.67,13.22,14.74,42.46,22.3C184.71,485,226,489.5,269.62,489.5s84.91-4.54,115.74-12.1c29.24-7.56,42.45-16.63,42.45-22.3V183.69c0-5.67-13.21-14.74-42.45-22.3-30.83-7.94-72.09-12.1-115.74-12.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ae273bfa-cafb-46e3-b43b-39332eacf46d",
  d: "M211.16,307.31a45,45,0,1,1,44.75-45.25v.09C255.91,286.82,235.83,307.31,211.16,307.31Zm0-73.19a28.44,28.44,0,1,0,28.43,28.45h0a28.47,28.47,0,0,0-28.43-28.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ae273bfa-cafb-46e3-b43b-39332eacf46d",
  d: "M320.73,307.31a45.17,45.17,0,1,1,45.17-45.17h0A45.24,45.24,0,0,1,320.73,307.31Zm0-73.19a28.44,28.44,0,1,0,28.44,28.44,28.44,28.44,0,0,0-28.44-28.44Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "ae273bfa-cafb-46e3-b43b-39332eacf46d",
  cx: 211.16,
  cy: 262.15,
  r: 9.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "ae273bfa-cafb-46e3-b43b-39332eacf46d",
  cx: 320.75,
  cy: 262.16,
  r: 9.2,
  transform: "translate(10.58 536.76) rotate(-80.78)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a614a534-8121-49d3-974d-b101f0a427be",
  d: "M269.94,10C175.83,10,39.35,60.16,34.27,221.11l-9.78,4.61c-18.29,5.26-14,29.53-14.12,48.56L10,327.93v21.46c.14,23.75,39.8,20.1,63.55,20V371a9.76,9.76,0,0,0,9.81,9.69H98.69a9.75,9.75,0,0,0,9.79-9.71V225.71h0A9.76,9.76,0,0,0,98.67,216H85.5c6.16-95.85,86.07-159.69,184.44-159.69h-.59c98.37,0,178.28,63.84,184.44,159.69H440.62a9.76,9.76,0,0,0-9.81,9.71h0V371a9.74,9.74,0,0,0,9.79,9.71h15.33a9.76,9.76,0,0,0,9.81-9.69v-1.66c23.75.14,63.4,3.79,63.55-20V327.93l-.38-53.65c-.08-19,4.18-43.3-14.11-48.56L505,221.11C499.94,60.16,363.46,10,269.35,10"
})));

function SvgLogoIconInverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 539.29 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconInverse);
export default __webpack_public_path__ + "static/media/logo-icon-inverse.3d05c1be.svg";
export { ForwardRef as ReactComponent };